import { Button, styled } from "@mui/material";

const SecondaryButton = styled(Button)({
  textTransform: "none",
});

export default SecondaryButton;
